import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { LoginService } from "../../../../providers/login.provider";
import { MenuService } from "../../../../providers/data/menu/menu.service";
import { UsersProvider } from 'app/providers/users.provider';
import { DOCUMENT } from '@angular/common';
import { AppConfigService } from 'app/providers/data/app-config.service';
import { DocumentProvider } from 'app/providers/documents.register.provider';
import { MatDialog } from '@angular/material/dialog';
import { InformationModalComponent } from 'app/main/sample/information-modal/information-modal.component';

@Component({
    selector     : 'login-2',
    templateUrl  : './login-2.component.html',
    styleUrls    : ['./login-2.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class Login2Component implements OnInit
{
    dialogRef:any;
    loginForm: FormGroup;
    typePassword:String = 'password';
    txt_tooltip_pass:String = 'mostrar contraseña'
    showPass:boolean = false;
    credentialError:boolean = false;
    loading:boolean = false;
    isAdvisorCitizen:boolean = false;
    valueLoading:number = 0;
    msjError = '';
    userIncorrect = 'Usuario o contraseña incorrectos';
    employeeIncorrect = 'Datos no encontrados en el sistema';

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private router: Router,
        private _activatedRoute: ActivatedRoute,
        private _loginService: LoginService,
        private _userService: UsersProvider,
        private _menuService: MenuService,
        private _settings: AppConfigService,
        private _documentService: DocumentProvider,
                public _matDialog: MatDialog,
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: true
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {   
        sessionStorage.clear();
        this._cleanClassList();
        this._validTypeLogin();
        this.loginForm = this._formBuilder.group({
            email   : ['', [Validators.required]],
            password: ['', Validators.required],
            clav    : [false]
        });
    }

    _validTypeLogin() {
        const typeLogin    = this._activatedRoute.snapshot.params.advisor;
        if(typeLogin === 'advisor-citizen') {
            this.isAdvisorCitizen = true;
        }
    }

    /**
     * show password
     */
    showPassword(): void {
        this.typePassword = 'password';
        this.txt_tooltip_pass = 'mostrar contraseña';
        if(!this.showPass) {
            this.typePassword = 'text';
            this.txt_tooltip_pass = 'ocultar contraseña';
        }
        this.showPass = !this.showPass;
    }
    openModalInformation(){
        console.log("hace peticion a calendario");
        //aqui va consulta back para guardia
        this._documentService.getcalendarioguard().subscribe(
          (response)=>{
              if(response !=null){
                  this.dialogRef = this._matDialog.open(InformationModalComponent, {panelClass: ''});
              }
  
          }
        );
      }
    /**
     * Valid credentetials
     */
    validCredential(): void {
        this.loading = true;
        this.resetCredendtialError();
        console.log(this.isAdvisorCitizen);
        this.showSpinner();

        setTimeout(() => {
            if (this.loginForm.valid) {
                //const data = { nk: this.loginForm.value.email, pw: CryptoJS.AES.encrypt(this.loginForm.value.password, 'aS35LwFU?}{0').toString() };
                this._loginService.getTokenLogin(this.loginForm.value).subscribe(
                    (res) => {
                        sessionStorage.setItem('tk', (res['data'] !== null) ? res['data'].access_token : null);
                        //this.settingApp.setUserSetting('name', data.nk.replace('/\b\w/g', l => l.toUpperCase()));
                        this._loginService.getUser().subscribe(
                            (responseUser) => {
                                const user = responseUser['data'];
                                const typeUser = responseUser['data'].tipo;
                                const save_user = this._settings.toEncrypt(JSON.stringify(user));
                                sessionStorage.setItem('usr', save_user.toString());
                                this._menuService.setMenu(typeUser);
                                setTimeout(() => {
                                    this.navigateTo(user)
                                    this.openModalInformation();
                                }, 500);
                            },
                            (error) => console.error(error)
                        );
                    },
                    (error) => {
                        console.log(error);
                        this.msjError = this._settings._getMsjError(error);
                        this.credentialError = true;
                        this.loading = false;
                    }
                );
            }
            
        }, 1000);
    }
    
    /**
     * Reset error credentials
     */
    resetCredendtialError():void {
        this.credentialError = false;
        this.valueLoading = 0;
        this.validIsClave()
    }

    /**
     * show loading
     */
    showSpinner(){
        let itLoad = setInterval(() => {
            this.valueLoading += 20;
            if(this.valueLoading > 100) { clearInterval(itLoad); }
        }, 500);
    }

    /**
     * 
     * @param token redirect depend user
     */
    navigateTo(user) {
        if(user.tipo === 'empleado' || user.tipo === 'superadmin'){
            this._userService.getEmployeeData(user.empe).subscribe(
                (response) => {
                    const dataTrabajador = response['data'].trabdata.data;
                    const typeEmployee = dataTrabajador.pues;
                    const save_user = this._settings.toEncrypt(JSON.stringify(response['data'].depadata.data));
                    const save_trab = this._settings.toEncrypt(JSON.stringify(dataTrabajador));
                    sessionStorage.setItem('em', save_user.toString());
                    sessionStorage.setItem('trab', save_trab.toString());
                    this._menuService.setMenu(typeEmployee);
                    sessionStorage.setItem('tyem', typeEmployee);
                    /*if( dataTrabajador.nume === 'Actuario'){
                        //this.router.navigate(['notifications/mail/inbox']);
                        this.router.navigate(['inicio']);
                    }else*/ 
                    if(user.vfcd) {
                        if( typeEmployee === 'Secretario de acuerdos sala regional' || 
                        typeEmployee === 'Actuario' ||
                        typeEmployee === 'Asesor ciudadano' ||
                        typeEmployee === 'Magistrado' ||
                        typeEmployee === 'Secretario de estudio y cuenta' ||
                        typeEmployee === 'superadmin' ||
                        typeEmployee === 'Auxiliar de Secretario de Acuerdos'){
                        this.router.navigate(['inicio']);
                    }else{ this._isTypeEmployeeUnknown();  }
                    }else {
                        this.router.navigate(['pages/errors/error-500']);
                    }
                    
                },
                (error) => console.error(error)
            );
        }else {
            if(user.vfcd) {
                this._getInfoCitizenAuthoritie(user);
            }else {
                this.router.navigate(['pages/errors/error-500']);
            }
        }
    }

    _getInfoCitizenAuthoritie(user){
        const typeUser = user.ciud !== 0 ? 'getCitizenById' : 'getAutorityById';
        const user_num = user.ciud !== 0 ? user.ciud : user.auto;
        this._userService[typeUser](user_num).subscribe(
            (response) => {;
                const save_user = this._settings.toEncrypt(JSON.stringify(response['data']));
                sessionStorage.setItem('tyus', save_user.toString());
                const toNavigate = this.isAdvisorCitizen ? '/pages/auth/adviser-citizen-form' : 'inicio';
                this.router.navigate([toNavigate]);
            },
            (error) => console.error(error)
        );
    }

    /* JWT */
    parseJwt (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');

        const base642 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base642).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        console.log('json ', jsonPayload)
        return JSON.parse(window.atob(base64));
    }

    _isTypeEmployeeUnknown(){
        this.msjError = this.employeeIncorrect;
        this.credentialError = true;
        this.loading = false;
        sessionStorage.clear()
    }

    validIsClave() {
        const reg = /^([0-9]){3,10}$/;
        this.loginForm.patchValue({ clav: reg.test(this.loginForm.value.email) ? 1 : 0 });
    }

    _cleanClassList(){
        for ( let i = 0; i < this.document.body.classList.length; i++ )
        {
            const className = this.document.body.classList[i];

            if ( className.startsWith('theme-') )
            {
                this.document.body.classList.remove(className);
            }
        }
        this.document.body.classList.add('theme-default');
    }
}
